// src/components/probe/ProbeHistory.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons'; // Import the 'x' icon


interface ProbeHistoryProps {
  history: string[];
  onSelect: (requestId: string) => void;
  onDelete: (requestId: string) => void;
}

const ProbeHistory: React.FC<ProbeHistoryProps> = ({ history, onSelect, onDelete }) => {
  return (
    <div className="p-4 border-b border-border-dark">
      <h3 className="text-lg font-semibold mb-3 text-text-light">Recent Probes</h3>
      {history.length === 0 ? (
        <p className="text-text-dark text-sm">No recent probes.</p>
      ) : (
        <ul className="space-y-2">
          {history.map((id, index) => (
           <li key={index} className="flex items-center justify-between group"> {/* Added group for hover effect */}
              <button onClick={() => onSelect(id)} className="bg-transparent border-none p-0 text-link-color hover:text-accent-color hover:underline text-sm break-all text-left w-full focus:outline-none"
              >
                {id}
            </button>
            <button
                onClick={(e) => {
                    e.stopPropagation(); // Prevent onSelect from firing when delete is clicked
                    onDelete(id);
                }}
                className="ml-2 p-1 text-text-dark hover:text-error-color opacity-0 group-hover:opacity-100 transition-opacity duration-200" // Hidden by default, visible on li hover
                title={`Remove ${id} from history`}
                >
                <FontAwesomeIcon icon={faTimes} />                
            </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ProbeHistory;